import React from 'react';
import PropTypes from 'prop-types';

const EstimationHeader = ({ t }) => (
    <header className="estimation-header">
        <h2 className="estimation-header-title">{ t('estimation.header.title') }</h2>
        <h3 className="estimation-header-subtitle">{ t('estimation.header.subtitle') }</h3>
    </header>
);

EstimationHeader.propTypes = {
    t: PropTypes.func.isRequired
};

export default EstimationHeader;



// WEBPACK FOOTER //
// ./src/components/content/estimation/EstimationHeader.jsx